<template>
    <div id="accessStoreInfo" ref="accessStoreInfo">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2">
                <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
            </el-col>
            <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
            </el-col>
        </el-row>
        <el-col class="fl searthPart no-print">
            <!-- <p class="headerT">出入库信息</p> -->
            <el-form ref="returnForm" :model="returnForm" :inline="true" id="test"  label-width="100px" :label-position="labelPosition">
                <el-form-item label="出入库编号:">
                    <el-input :disabled="true" :value="returnForm.code"></el-input>
                    <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(returnForm.code,$event)"></i>
                </el-form-item>
                <el-form-item label="出入库类型:">
                    <el-input :disabled="true" v-model="returnForm.type"></el-input>
                </el-form-item>
                <el-form-item label="出入库仓库:">
                    <el-input :disabled="true" v-model="returnForm.warehouseType" ></el-input>
                </el-form-item>
                <el-form-item label-width="60px" label="状态:">
                    <el-input :disabled="true" v-if="returnForm.status == 'YQR'" value="已确认"></el-input>
                    <el-input :disabled="true" v-else-if="returnForm.status == 'CG'" value="暂存"></el-input>
                    <el-input :disabled="true" v-else value="已完成"></el-input>
                </el-form-item>
                <el-form-item label-width="80px" label="操作人:">
                    <el-input :disabled="true" v-model="returnForm.createUser" ></el-input>
                </el-form-item>
                <el-form-item label="提交时间:">
                    <el-input :disabled="true" v-model="returnForm.createTime" ></el-input>
                </el-form-item>
                <el-form-item label-width="80px" label="供应商:" v-if="returnForm.relatedId !== '' && returnForm.relatedId !== undefined">
                    <el-input :disabled="true" v-model="returnForm.supplierName"></el-input>
                </el-form-item>
                <el-form-item label="备注信息:">
                    <el-input :disabled="true" v-model="returnForm.memo" ></el-input>
                </el-form-item>
            </el-form>
            <!-- <p class="headerT">关联信息</p> -->
            <!-- <el-form ref="returnForm" :model="returnForm" label-width="120px" :label-position="labelPosition">
                <el-form-item label="供应商:" v-if="returnForm.relatedId !== '' && returnForm.relatedId !== undefined">
                    <el-input :disabled="true" v-model="returnForm.supplierName"></el-input>
                </el-form-item>
                <el-form-item label="备注信息:">
                    <el-input :disabled="true" v-model="returnForm.memo" ></el-input>
                </el-form-item>
            </el-form> -->
        </el-col>
        <el-col class="fr" >
            <el-card class="box-card fr" style="width:100%">
                <el-table
                    :data="returnData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    :summary-method="getSummaries"
                    show-summary
                    >
                    <el-table-column
                        align="center"
                        type="index"
                        width="50"
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialCode"
                        label="物料编号">
                    </el-table-column> 
                    <el-table-column
                        align="center"
                        prop="modelName"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialName"
                        label="物料名称">
                    </el-table-column>
                    <el-table-column
                        v-if="returnForm.type != '物料出库'"
                        align="center"
                        prop="aogSum"
                        width="100"
                        label="到货数量">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="inboundSum"
                        width="100"
                        :label="returnForm.type == '物料出库' ? '出库数量' : '入库数量'">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="price"
                        width="100"
                        label="入库单价">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="shouldInPrice"
                        width="100"
                        label="应入价">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="amount"
                        width="100"
                        label="合计金额">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="操作">
                        <template slot-scope="scope">
                            <el-button @click.stop="showSerialNumber(scope.$index, scope.row)" type="text" size="small">查看序列号</el-button>
                            <el-button @click.stop="addPreviewBarCode(scope.$index, scope.row)" type="text" size="small">条形码打印预览</el-button>
                            <el-button @click.stop="addBarCode(scope.$index, scope.row)" type="text" size="small">补印条形码</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table
                    id="tableId"
                    :data="returnData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    :summary-method="getSummaries"
                    show-summary
                    style="display:none"
                    >
                    <el-table-column
                        align="center"
                        type="index"
                        width="110"
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="110"
                        prop="materialCode"
                        label="物料编号">
                    </el-table-column> 
                    <el-table-column
                        align="center"
                        width="110"
                        prop="modelName"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="110"
                        prop="materialName"
                        label="物料名称">
                    </el-table-column>
                    <el-table-column
                        v-if="returnForm.type != '物料出库'"
                        align="center"
                        prop="aogSum"
                        width="110"
                        label="到货数量">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="inboundSum"
                        width="110"
                        :label="returnForm.type == '物料出库' ? '出库数量' : '入库数量'">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="price"
                        width="110"
                        label="入库单价">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="amount"
                        width="110"
                        label="合计金额">
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-col :span="24" class="toolbar">
                    <div class="pagination">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pages.page"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pages.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="pages.total">
                        </el-pagination>
                    </div>
                </el-col>
            </el-card>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="printTable()">打印入库记录</el-button>
            <el-button id="form1" type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="PrintingBarCode()">全部打印条形码</el-button>
            <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="PrintingPreviewRecord()">全部条形码打印预览</el-button>
        </el-col>
        <el-col id="formTable" style="display: none">
            <table>
                <tr>
                    <th colspan="8">出入库信息</th>
                </tr>
                <tr>
                    <th>出入库编号:</th>
                    <th>出入库类型:</th>
                    <th>出入库仓库:</th>
                    <th>状态:</th>
                    <th>操作人:</th>
                    <th>提交时间:</th>
                </tr>
                <tr>
                    <td>{{returnForm.code}}</td>
                    <td>{{returnForm.type}}</td>
                    <td>{{returnForm.warehouseType}}</td>
                    <td>已完成</td>
                    <td>{{returnForm.createUser}}</td>
                    <td>{{returnForm.createTime}}</td>
                </tr>
                <tr>
                    <th colspan="8">关联信息</th>
                </tr>
                <tr>
                    <th colspan="4">关联采购订单:</th>
                    <th colspan="4">备注信息:</th>
                </tr>
                <tr>
                    <td colspan="4">{{returnForm.relatedId}}</td>
                    <td colspan="4">{{returnForm.memo}}</td>
                </tr>
            </table>
        </el-col>        
        <!-- 查看序列号弹出框 -->
        <el-dialog  class="dialog-content" :visible.sync="dialogTableVisible">
            <el-row 
                class="dialog-code-content" 
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading">
                <el-col v-for="(item,index) in checkCodeList" v-if="item != ''" :key="index" :span="6">
                    <p>{{item}}</p>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import Vue from 'vue'
    let moment = require("moment");
    import Print from '@/util/print'
    Vue.use(Print)
    import clip from '@/util/clipboard'
    import {needCLodop,getLodop} from '@/util/LodopFuncs'
    import {
        inboundDetails,
        inboundDetailsList
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'accessStoreInfo',
        components: {},
        data () {
            return {
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 50,
                },
                valueTime:'',
                orderId:'',
                orderStates:[{name:'订单详情'},{name:'订单事件'},],
                labelPosition:'left',
                returnForm:{},
                returnData: [],
                dialogTableVisible: false, //弹出框
                checkCodeList:[],
                codeList:[], //序列号数组
                // basicsAuth:{
                //     printAllCodeShow:false,
                //     printAllCode:false,
                //     printStorageRecord:false

                // }
            }
        },
        created:function(){
            this.$destroy(); //销毁生命周期
            if (!this.$route.query.orderId) {
                var userOrderId = sessionStorage.getItem('saveOrderId');
                this.orderId = JSON.parse(userOrderId);
            }else{
                let orderId = this.$route.query.orderId
                this.orderId = orderId
            }
            this.getInboundDetails()     //获取出入库信息
            this.getInboundDetailsList() //获取物料信息
            if (this.returnData.amout > 0) {
                this.returnData.amout = this.returnData.amout.toFixed(2)
            }
           
        },
        mounted(){
            // this.basicsAuth.printAllCodeShow = getPermission('/api/inbound/printAllCodeShow');
            // this.basicsAuth.printAllCode = getPermission('/api/inbound/printAllCode');
            // this.basicsAuth.printStorageRecord = getPermission('/api/inbound/printStorageRecord');
            
        },
        methods: {
            //打印出入库
            printTable(){
                let LODOP=getLodop(); 
                    LODOP.SET_PRINT_PAGESIZE(3, '100%', '100%',"Letter"); 
                    let tableStyle="<style>table{display:flex;text-align:center}td,th{border:1px solid #333;width:110px;line-height:1.8}button{background-color:transparent;border:none;color:#333}</style>";

                    let formStyle="<style>table{display:flex;border-collapse:collapse;text-align:center}td,th{border:1px solid #333;width:110px;line-height:2}</style>";
                    let strFormHtml = formStyle+"<body>"+document.getElementById("formTable").innerHTML+"</body>";
                    let strTableHtml= tableStyle+"<body>"+document.getElementById("tableId").innerHTML+"</body>";             
                    LODOP.PRINT_INIT("打印出入库记录");
                    LODOP.ADD_PRINT_HTM(88,0,'100%','100%',strFormHtml+"<br/>"+strTableHtml)
                    //LODOP.NEWPAGE();
                    //LODOP.ADD_PRINT_TEXT(50,50,260,39,"");
                    //LODOP.ADD_PRINT_HTM(88,50,'100%','100%',strTableHtml);
                    LODOP.SET_SHOW_MODE("LANDSCAPE_DEFROTATED",1);//横向时的正向显示
                    LODOP.PREVIEW();
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getInboundDetailsList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getInboundDetailsList()
            },
            //获取订单详情
            getInboundDetails() {
                let para={
                    id: this.orderId,
                }
                inboundDetails(para).then(res => {
                    if (res.data.status == '100') {
                        this.returnForm = res.data.results.inboundInfo
                        this.returnForm.createTime = this.filters.formatDate(this.returnForm.createTime)
                        sessionStorage.setItem('saveOrderId', JSON.stringify(res.data.results.inboundInfo.id));
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                  this.$Message.error(error.message);
                })
            },
            //获取订单详情分页
            getInboundDetailsList() {
                let para={
                    id: this.orderId,
                    startRow:this.pages.page,
                    pageSize:this.pages.pageSize
                }
                inboundDetailsList(para).then(res => {
                    if (res.data.status == '100') {
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total
                        this.codeList = [];
                        this.returnData.forEach((item,index)=>{
                            let arr = item.attribute1.split(',');
                            arr.forEach((item1,index1)=>{
                                if(item1 == "" || typeof(item1) == "undefined"){
                                    arr.splice(index1,1);                                                 
                                }
                            })
                            let obj = {
                                materialCode:item.materialCode,
                                materialName:item.materialName,
                                list:arr
                            }
                            this.returnData[index].list = arr;
                            this.codeList.push(obj);
                        })
                        console.log(this.codeList)
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                  this.$Message.error(error.message);
                })
            },
            //查看序列号
            showSerialNumber(index, row) {
                this.dialogTableVisible = true
                this.checkCodeList = Object.assign({}, row).list
            },
            //补印条形码
            addBarCode(index, row){
                let arr = []
                let data = Object.assign({}, row);
                arr.push(data)
                this.PrintingRecord(arr,1)
            },
            //补印条形码预览
            addPreviewBarCode(index, row){
                let arr = []
                let data = Object.assign({}, row);
                arr.push(data)
                this.PrintingRecord(arr,0);
            },
            //条形码打印*预览
            PrintingRecord(data,type){  //type:0=》预览 1=》打印
                let LODOP = getLodop();
                LODOP.PRINT_INITA(0,0,600,600,"");
                data.forEach((item,index)=>{
                    item.list.forEach((item1,index1) =>{
                        LODOP.ADD_PRINT_BARCODE(14, 132, 118, 23, "Code39", item1);
                        LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
                        LODOP.ADD_PRINT_BARCODE(14, 5, 118, 26, "Code39", item.materialCode);
                        LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
                        LODOP.ADD_PRINT_TEXT(50, 3, 120, 44, item.materialName);
                        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
                        LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
                        LODOP.ADD_PRINT_BARCODE(55, 132, 118, 23, "Code39", item1);
                        LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
                        LODOP.ADD_PRINT_BARCODE(97, 132, 118, 23, "Code39", item1);
                        LODOP.SET_PRINT_STYLEA(0, "FontSize",7);
                        LODOP.NEWPAGE();

                        // LODOP.ADD_PRINT_BARCODE(267, 215, 118, 23, "Code39", item1);
                        // LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
                        // LODOP.ADD_PRINT_BARCODE(267, 89, 118, 26, "Code39", item.materialCode);
                        // LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
                        // LODOP.ADD_PRINT_TEXT(303, 87, 117, 44, item.materialName);
                        // LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
                        // LODOP.SET_PRINT_STYLEA(0, "FontSize", 9);
                        // LODOP.ADD_PRINT_BARCODE(309, 215, 118, 23, "Code39", item1);
                        // LODOP.SET_PRINT_STYLEA(0, "FontSize", 7);
                        // LODOP.ADD_PRINT_BARCODE(348, 215, 118, 23, "Code39", item1);
                        // LODOP.SET_PRINT_STYLEA(0, "FontSize",7);
                        // LODOP.NEWPAGE();
                    })
                })
                if(type == 0)LODOP.PREVIEW(); 
                else LODOP.PRINT();              
            },
            //全部打印条形码
            PrintingBarCode(){
                this.PrintingRecord(this.codeList,1)
            },
            //全部条形码打印预览
            PrintingPreviewRecord(){
                this.PrintingRecord(this.codeList,0)
            },
            //复制内容
            handleCopy(text, event) {
                clip(text, event)
            },
            //返回上一页
            backGo() {
                this.$router.push({
                    path:'/accessStoreManage'
                })
            },
            refresh() {
                this.getInboundDetailsList()
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (index === 6 || index === 1 || index === 7) {
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '';
                    } else {
                        sums[index] = '';
                    }
                });
                // if (sums[5] > 0) {
                //     sums[7] = this.toThousands2(sums[7]);
                // }
                return sums;
            },
            //金额转化函数
            addCommas:function(row,column){
                var num = row[column.property];
                var b= num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            toThousands2(num) {
                num = num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            }
        },
        computed: {
        },
        watch: {},
    }
</script>


<style type="text/css" lang="scss" scoped>
    #accessStoreInfo{
        font-size: 14px;
        .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
        .el-input{width: 85%;}
        .headerT{font-size: 16px;margin:0 0 15px 0;}
        .activeBtn{background-color: #1abc9c;color:#fff;}
        .eventLi{border-left:1px solid #1abc9c;padding-bottom: 20px;
            .childSpan{padding-left: 20px;margin-bottom: 5px;}
            .childSpan:first-child{padding-left: 0px;margin:-5px 0 0 -5px;}
            .childSpan span.orderId{color: #3399FF;}
            .createTime i{display: block;width: 10px;height: 10px;border-radius: 20px;
                background-color: #1abc9c;margin: 0px 15px 0px -5px;}
        }
        .toolbar{margin: 20px 0;}
        .el-button+.el-button {
            margin-left: 0px;
        }
        .el-step__line{background-color: #1abc9c;}
        .el-step__icon-inner{color:#1abc9c;}
        /*.el-step__icon{width: 10px;height: 10px;}*/
        .el-step__icon.is-text{border-color: #1abc9c;}
    }
    .dialog-content{
        width:900px;
        margin:0 auto;
        .dialog-code-content{
            text-align: center;
            .el-col{
                p{
                    border: 1px solid #e3e3e3;
                    line-height: 40px
                }
                
            }
        }
    }
    
</style>



// WEBPACK FOOTER //
// accessStoreInfo.vue?ca05c4a8